import type { DesignProjectStatus, DesignStageKind, DesignStageStatus } from './types';

export const PROJECT_STATUS_LABEL: Record<DesignProjectStatus, string> = {
  en_planificacion: 'Planificación',
  en_revision: 'Revisión',
  en_verificacion: 'Verificación',
  en_validacion: 'Validación',
  completado: 'Completado',
  cancelado: 'Cancelado',
};

export const STAGE_KIND_LABEL: Record<DesignStageKind, string> = {
  planificacion: 'Planificación',
  revision: 'Revisión',
  verificacion: 'Verificación',
  validacion: 'Validación',
};

export const STAGE_STATUS_LABEL: Record<DesignStageStatus, string> = {
  pendiente: 'Pendiente',
  en_progreso: 'En progreso',
  aprobado: 'Aprobado',
  rechazado: 'Rechazado',
};

export function projectStatusBadgeClass(status: DesignProjectStatus): string {
  switch (status) {
    case 'completado':
      return 'bg-emerald-100 text-emerald-800';
    case 'cancelado':
      return 'bg-gray-100 text-gray-600';
    case 'en_validacion':
      return 'bg-violet-100 text-violet-800';
    default:
      return 'bg-sky-100 text-sky-800';
  }
}

export function stageStatusBadgeClass(status: DesignStageStatus): string {
  switch (status) {
    case 'aprobado':
      return 'bg-emerald-100 text-emerald-800';
    case 'rechazado':
      return 'bg-red-100 text-red-800';
    case 'en_progreso':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-slate-100 text-slate-700';
  }
}
